import React from 'react';
import { useTranslation } from 'react-i18next';

import UploadZone from '../components/upload-zone/UploadZone';

import scss from './SingleUploadZone.module.scss';

function SingleUploadZone({ onUploadMediaItems, disabled, onChangeErrors }) {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.uploadZoneWrapper}>
      <UploadZone
        onUploadMediaItems={onUploadMediaItems}
        onChangeErrors={onChangeErrors}
        labelText={t('uploadYourMediaFiles')}
        subLabelText={t('imagesAndVideosAreSupportedMultipleFilesAllowed')}
        disabled={disabled}
      />
    </div>
  );
}

export default SingleUploadZone;
